import { NgModule } from "@angular/core";
import { OnlineStatusComponent } from "./online-status";
import { IonicModule } from "ionic-angular";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [
        CommonModule,
        IonicModule
    ],
    declarations: [
        OnlineStatusComponent
    ],
    exports: [
        OnlineStatusComponent
    ],
    entryComponents: [
        OnlineStatusComponent
    ]
})
export class OnlineStatusModule {

}



// WEBPACK FOOTER //
// ./src/vas/modules-other/online-status/online-status.module.ts